namespace GeniuzPOS.Customer {
    export class Report_1106CustomerColumns {
        static columnsKey = 'Customer.Report_1106Customer';
    }
}
